if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        document.addEventListener('variant:change', (e) => {
  this.currentVariant = e.detail.variant;
  this.updateAddToCartText();
});

        this.submitButtonText = this.submitButton.querySelector('span');
        //this.submitButtonText = this.submitButton.querySelector('.button__text');
 


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
         // this.submitButtonText.textContent = window.variantStrings.addToCart;

          //this.submitButtonText.textContent='add to cart (30 ct)';

          
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// 👇 Subscribe to variant change event
subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
  const selectedText = data.target?.value?.toLowerCase?.() || '';

  const submitButtonText = document.querySelector('.product-form__submit .button__text');
     const productform = document.querySelector('.product-form__buttons');
      const customsubscriptionbox = document.querySelector('.custom-subscription-box');
            const  bundlebox = document.querySelector('.bundle-box');
             const   flavorbundlesubmit = document.querySelector('#flavor-bundle-submit');
   

  if (!submitButtonText) return;

  if (selectedText.includes('90')) {
      flavorbundlesubmit.style.display = 'flex';
     bundlebox.style.display = 'block';
      productform.style.display = 'none';
     // customsubscriptionbox.style.display = 'none';
    //submitButtonText.textContent = 'add to cart (90 ct)';
   
  } else if (selectedText.includes('30') || selectedText.includes('one time')) {
    
     flavorbundlesubmit.style.display = 'none';
   // bundlebox.style.display = 'none';
      customsubscriptionbox.style.display = 'block';
    submitButtonText.textContent = 'add to cart (30 ct)';
    productform.style.display = 'block';
  } else {
    submitButtonText.textContent = 'add to cart (30 ct)';
    productform.style.display = 'block';
  }
});

// ✅ Initial update on page load  
document.addEventListener('DOMContentLoaded', () => {

  

  const selectedInput = document.querySelector(
    '.product-form__input input[type="radio"]:checked, .product-form__input select'
  );

  const submitButtonText = document.querySelector('.product-form__submit .button__text');
    const productform = document.querySelector('.product-form__buttons');
  
  if (!submitButtonText || !selectedInput) return;

  const selectedValue = selectedInput.value.toLowerCase();

  if (selectedValue.includes('90')) {
   
     productform.style.display = 'none';
    //submitButtonText.textContent = 'add to cart (90 ct)';
          
  
  } else if (selectedValue.includes('30') || selectedValue.includes('one time')) {
     
    submitButtonText.textContent = 'add to cart (30 ct)';
       productform.style.display = 'block';
  } else {
    submitButtonText.textContent = 'add to cart (30 ct)';
       productform.style.display = 'block';
  }
});

